import React from 'react';
import MaestroLogo from '@tradera/blueprint/theme/logos/maestro_vertical.svg?jsx';
import MasterCardLogo from '@tradera/blueprint/theme/logos/mastercard_vertical.svg?jsx';
import PaynovaLogo from '@tradera/blueprint/theme/logos/paynova.svg?jsx';
import PaypalLogo from '@tradera/blueprint/theme/logos/paypal.svg?jsx';
import SwishLogo from '@tradera/blueprint/theme/logos/swish_horizontal.svg?jsx';
import VisaLogo from '@tradera/blueprint/theme/logos/visa.svg?jsx';
import GooglePayLogo from '@tradera/blueprint/theme/logos/google-pay.svg?jsx';
import ApplePayLogo from '@tradera/blueprint/theme/logos/apple-pay.svg?jsx';
import KlarnaLogo from '@tradera/blueprint/theme/logos/klarna.svg?jsx';
import TraderaLogo from 'tradera/legacy/static/components/tradera/logo';

import style from './payment-method-logo.module.scss';

const PaymentMethodLogo = ({ paymentMethod, displayText }) => {
    const visaLogo = (
        <div
            key={paymentMethod}
            className={`${style.logoWithBorder} ${style.narrow}`}
            style={{ padding: '6px' }}
            title={displayText}>
            <VisaLogo />
        </div>
    );
    const mastercardLogo = (
        <div
            key={paymentMethod}
            className={`${style.logoWithBorder} ${style.narrow} justify-content-center`}
            style={{ padding: '3px' }}
            title={displayText}>
            <MaestroLogo />
            <MasterCardLogo />
        </div>
    );
    switch (paymentMethod) {
        case 'Visa':
            return visaLogo;
        case 'Mastercard':
            return mastercardLogo;
        case 'VisaMasterCard':
            return (
                <div key={paymentMethod} className="d-flex">
                    <div style={{ marginRight: '2px' }}>{visaLogo}</div>
                    {mastercardLogo}
                </div>
            );
        case 'Paynova':
            return (
                <div
                    key={paymentMethod}
                    className={style.logoWithBorder}
                    title={displayText}>
                    <PaynovaLogo />
                </div>
            );
        case 'PayPal':
            return (
                <div
                    key={paymentMethod}
                    className={style.logoWithBorder}
                    title={displayText}>
                    <PaypalLogo />
                </div>
            );
        case 'SwishApp2App':
        case 'SwishHandel':
            return (
                <div
                    key={paymentMethod}
                    className={style.logoWithBorder}
                    title={displayText}>
                    <SwishLogo />
                </div>
            );
        case 'ApplePay':
            return (
                <ApplePayLogo
                    key={paymentMethod}
                    className={style.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'GooglePay':
            return (
                <GooglePayLogo
                    key={paymentMethod}
                    className={style.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'Klarna':
            return (
                <KlarnaLogo
                    key={paymentMethod}
                    className={style.logoWithoutBorder}
                    alt={displayText}
                />
            );
        case 'Invoice':
            return (
                <TraderaLogo
                    key={paymentMethod}
                    className={style.logoWithBorder}
                    alt={displayText}
                />
            );
        default:
            return null;
    }
};

export default PaymentMethodLogo;
